
function ItemCard({ icon, name, symbol, bal, balusd, currency = "$" }) {
    return (
      <div className="itemcard">
        <div className="d-flex align-items-center">
            {icon}
            <div className="ms-3">
                <h6 className="mb-0 fw-bold text-white" style={{fontSize: '18px'}}>{name}</h6>
                <p className="mb-0 fw-bold text-secondary" style={{fontSize: '15px'}}>{symbol}</p>
            </div>
        </div>
        <div className="ms-3 text-end">
            <h6 className="mb-0 fw-bold text-white" style={{fontSize: '18px'}}>{(currency)?currency:'$'}{balusd}</h6>
            <p className="mb-0 fw-bold text-secondary" style={{fontSize: '15px'}}>{bal} {symbol}</p>
        </div>
      </div>
    )
  }
  
  export default ItemCard